import React from "react";
import $ from "jquery";
import {WebService} from "../../module/WebService";
import {AppConfig} from "../../AppConfig";
import 'bootstrap/dist/css/bootstrap.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import LoadingImage from "../LoadingImage";
import axios from "axios";
import {globalSession} from "../../module/Session";


class UserFormEdit extends React.Component {

    webService = new WebService();
    urlSearchParams = new URLSearchParams(window.location.search);

    constructor(props) {
        super(props);
        this.state = {fullName: ""};
        this.originalData = {};
    }

    componentDidMount() {
        axios.get(AppConfig.server + AppConfig.service.admin.users + "/" + this.urlSearchParams.get("userId"), globalSession.getAuthToken())
            .then((res) => {
                const data = res.data;
                if (data.success) {
                    this.successGetUser(data["data"]);
                } else
                    this.failGetUser();
            })
            .catch(e => {
                this.failGetUser();
            })
    }

    successGetUser(data) {
        this.originalData = data;

        $("#name").val(data["name"]);
        $("#surname").val(data["surname"]);
        $("#registryNo").val(data["registryNo"]);
        $("#Pass1Edit").val("");
        //$("#Pass2Edit").val("");
        if (data["contact"] != null) {
            $("#mailEdit").val(data["contact"]["mail"]);
            $("#phone").val(data["contact"]["phone"]);
        } else {
            $("#mailEdit").val("");
            $("#phone").val("");
        }
        $("#active").prop("checked", data["active"]);


        if (data["roles"][0]["name"] === "ADMIN") {
            $("#radioRoleAdmin").prop("checked", true);
            $("#radioRoleOperator").prop("checked", false);
        } else {
            $("#radioRoleOperator").prop("checked", true);
            $("#radioRoleAdmin").prop("checked", false);
        }

        this.setState({"fullName": "Düzenle: " + data["registryNo"] + " - " + data["name"] + " " + (data["surname"] != null ? data["surname"] : "")})

    }

    failGetUser() {
        alert("Kullanıcı Bulunamadı");
    }

    send() {

        const _name = $("#name").val();
        const _registryNo = $("#registryNo").val();
        const _surname = $("#surname").val();
        const _pass1 = $("#Pass1Edit").val();
        //const _pass2 = $("#pass2").val();
        const _mail = $("#mailEdit").val();
        const _phone = $("#phone").val();
        const _active = $("#active").prop("checked");

        alert(_active);
        const _roleId = $("input[name='roles']:checked").val();

        let sendNewData = false;
        const newData = {id: parseInt(this.urlSearchParams.get("userId"))};


        /*const data = JSON.stringify({
            registryNo: _registryNo,
            name: _name,
            surname: _surname,
            password: _pass1,
            mail: _mail,
            phone: _phone
        });*/

        if (this.originalData["name"] !== _name) {
            if (_name.length > 3) {
                sendNewData = true;
                newData["name"] = _name;
            } else {
                alert("Ad en az 3 karakterli olmalı");
                return;
            }
        }

        if (this.originalData["surname"] !== _surname) {
            if (_surname.length > 3) {
                sendNewData = true;
                newData["surname"] = _surname;
            } else {
                alert("Soyad en az 3 karakterli olmalı");
                return;
            }
        }

        if (this.originalData["registryNo"] !== _registryNo) {
            if (_registryNo.length >= 3 && (/[\d]{3,}/.test(_registryNo))) {
                sendNewData = true;
                newData["registryNo"] = _registryNo;
            } else {
                alert("Geçersiz sicil no");
                return;
            }
        }


        if (this.originalData["contact"] != null) {
            if (this.originalData["contact"]["mail"] !== _mail) {
                const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

                if ("" === _mail)
                    newData["contact"] = {mail: _mail};
                else if (_mail.length >= 3 && (re.test(_mail))) {
                    sendNewData = true;
                    newData["contact"] = {mail: _mail};
                } else {
                    alert("Geçersiz e-posta adresi");
                    return;
                }
            }

            if (this.originalData["contact"]["phone"] !== _phone) {
                sendNewData = true;
                newData["contact"] = {phone: _phone};
            }
        }
        if (_pass1.length > 3) {
            sendNewData = true;
            newData["password"] = _pass1;
        }

        newData["active"] = _active;
        newData["roles"] = [{"name": _roleId}];

        let confirmedForm = true;
        //let failMsg = "";

        alert(JSON.stringify(newData));
        if (confirmedForm) {
            if (sendNewData) {
                $("#loadingImg").css({display: "block"});


                axios.put(AppConfig.server + AppConfig.service.admin.users, newData, globalSession.getAuthToken())
                    .then((res) => {
                        const data = res.data;
                        if (data.success) {
                            this.success();
                        } else
                            this.fail();
                    })
                    .catch(e => {
                        this.fail();
                    })
            }
        } else {
            this.fail();
        }
    }

    success() {
        $("#errorMsg").css({display: "none"}).html("");
        $("#successMsg").css({display: "block"}).html("Başarılı");
        $("#loadingImg").css({display: "none"});
    }

    fail() {
        $("#errorMsg").css({display: "block"}).html("Başarısız");
        $("#successMsg").css({display: "none"}).html("");
        $("#loadingImg").css({display: "none"});
    }


    render() {
        return (
            <div style={{width: "100%"}}>
                <div style={{width: 600 + "px", margin: "125px auto"}}>
                    <div className="card">
                        <article className="card-body">
                            <h4 className="card-title text-center mb-4 mt-1"><strong>{this.state.fullName}</strong></h4>
                            <hr/>
                            <p id={"errorMsg"} className="text-danger text-center"/>
                            <p id={"successMsg"} className="text-success text-center"/>
                            <form>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="key"/></span>
                                        </div>
                                        <input id="registryNo" autoComplete="off" name="" className="form-control"
                                               placeholder="Sicil No."
                                               type="number"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="user"/></span>
                                        </div>
                                        <input id="name" autoComplete="off" name="" className="form-control"
                                               placeholder="Ad" type="text"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="user"/></span>
                                        </div>
                                        <input id="surname" autoComplete="off" name="" className="form-control"
                                               placeholder="Soyad"
                                               type="text"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="at"/></span>
                                        </div>
                                        <input id="mailEdit" autoComplete="off" name="" className="form-control"
                                               placeholder="E-mail"
                                               type="email"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="phone"/></span>
                                        </div>
                                        <input id="phone" autoComplete="off" name="" className="form-control"
                                               placeholder="Telefon"
                                               type="text"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <i className="fa fa-lock"/> </span>
                                        </div>
                                        <input id="Pass1Edit" autoComplete="new-password" name="editPass1"
                                               className="form-control" placeholder="Şifre" type="text"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="form-check">
                                        <div className="form-check">
                                            <input type="radio" name="roles" value="ADMIN" id="radioRoleAdmin"
                                            /> Admin&nbsp;&nbsp;&nbsp;
                                            <input type="radio" name="roles" value="OPERATOR" id="radioRoleOperator"
                                            /> Operator
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group" style={{paddingLeft: "40px"}}>
                                    <div className="form-check">
                                        <label className="form-check-label">
                                            <input id="active" name="active" type="checkbox"
                                                   className="form-check-input"/> Aktif
                                        </label>
                                    </div>
                                </div>
                                {/*<div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <i className="fa fa-lock"/> </span>
                                        </div>
                                        <input id="Pass2Edit" autoComplete="new-password" name="editPass2" className="form-control" placeholder="Şifre Tekrarı"
                                               type="password"/>
                                    </div>
                                </div>*/}
                                <div className="form-group">
                                    <button onClick={this.send.bind(this)} type="button"
                                            className="btn btn-primary btn-block"> Kaydet
                                    </button>
                                </div>
                                <p style={{display: "none"}} id="loadingImg"><LoadingImage/></p>
                                <input type="hidden" value="prayer"/>
                            </form>
                        </article>
                    </div>
                </div>
            </div>
        )
    }

}

export default UserFormEdit;